import React from 'react'
import Swal from 'sweetalert2';
import PageHeaderLayout from '../../../components/Layout/PageHeaderLayout';
import { Refresh } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { Card, Chip, Typography, Stack, TextField, Grid, Button, Box, Tooltip, IconButton, Badge, Avatar, useTheme, useMediaQuery } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import { formatDateTime } from '../../../utils/dateUtils';
import { useForm, FormProvider, Controller, set } from 'react-hook-form';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import SearchIcon from '@mui/icons-material/Search';
import NoRowsLayout from '../../../components/Layout/NoRowsLayout';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import calculateAge from '../../../utils/ageCalculation';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import { PermissionGuard } from '../../../components/PermissionGuard';
import { Helpers } from '../../../services/Helpers';
import Loading from '../../../components/Loader/Loading';
// import ExportAll from './filterAndExport/ExportAll';
import MultiColumnFilter from '../../../components/Filter/MultiColumnFilter';
import { materializeViewServices } from './services';
import { ProviderServices } from '../../Provider/CrudServices';
import MaterializeFilter from './MaterializeFilter';



export default function ProviderServiceList() {

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  const handleRefreshList = async () => {
    Swal.fire({
        title: 'Processing Data',
        text: 'Please wait while we processing Submission request...',
        icon: 'info',
        allowOutsideClick: false,
        didOpen: () => {
            Swal.showLoading();
        }
    })
    const refreshResponse = await materializeViewServices.refreshMaterializedView();
    if (refreshResponse.status == 'success') {
      await fetchList();
      Swal.fire({
        title: 'Refreshed!',
        text: refreshResponse.message,
        icon: 'success',
        timer: 2000
      })
    } else {
      Swal.fire({
        title: 'Error!',
        text: refreshResponse.message,
        icon: 'error',
        confirmButtonText: 'OK'
      })
    }
  }

  // Grid API Reference
  const navigate = useNavigate();

  /************************  Table Data State Manage **************************** */

  const columns = [
    {
      field: 'id',
      headerName: 'ID',
      headerAlign: 'center', sortable: false,
      filterable: false,
      flex: .5,
      renderCell: (params) => (
        <Box sx={{ width: 'max-content', m: 'auto' }}>
          <Chip
            label={params.row.id}
            size="small"
            sx={{ fontSize: '0.5rem', height: 'fit-content', py: '5%' }}
          />
        </Box>
      ),
    },
    {
      field: 'provider',
      headerName: 'Provider Details',
      headerAlign: 'center', sortable: false,
      filterable: false,
      flex: 2,
      renderCell: (params) => (
        <Box sx={{ width: '100%', m: 'auto',p:1 }}>
          <Box sx={{display:'flex'}}>
            <Typography sx={{fontWeight:500,fontSize:'.65rem',width:'25%'}}>Id</Typography>
            <Typography sx={{fontWeight:500,fontSize:'.65rem',flex:0.25}}>:</Typography>
            <Typography sx={{ fontSize: '0.65rem', color: '#3e3e3e', fontWeight: 400,flex:2 }}>
              {params.row.userId}
            </Typography>
          </Box>
          <Box sx={{display:'flex'}}>
            <Typography sx={{fontWeight:500,fontSize:'.65rem',width:'25%'}}>Name</Typography>
            <Typography sx={{fontWeight:500,fontSize:'.65rem',flex:0.25}}>:</Typography>
            <Typography sx={{ fontSize: '0.65rem', color: '#3e3e3e', fontWeight: 400,flex:2 }}>
              {params.row.firstName || ''} {params.row.middleName || ''} {params.row.lastName || ''}
            </Typography>
          </Box>
          <Box sx={{display:'flex'}}>
            <Typography sx={{fontWeight:500,fontSize:'.65rem',width:'25%'}}>Mobile </Typography>
            <Typography sx={{fontWeight:500,fontSize:'.65rem',flex:0.25}}>:</Typography>
            <Typography sx={{ fontSize: '0.65rem', color: '#3e3e3e', fontWeight: 400,flex:2 }}>
              {params.row.mobileNumber}
            </Typography>
          </Box>
          <Box sx={{display:'flex'}}>
            <Typography sx={{fontWeight:500,fontSize:'.65rem',width:'25%'}}>Coordinates</Typography>
            <Typography sx={{fontWeight:500,fontSize:'.65rem',flex:0.25}}>:</Typography>
            {/* <Typography sx={{ fontSize: '0.65rem', color: '#3e3e3e', fontWeight: 400,flex:2 }}>
              {params.row.mobileNumber}
            </Typography> */}
            <Card sx={{flex:2 ,p:1}}>
              {(params.row.coordinates )&& 
                <Typography sx={{ fontSize: '0.65rem', color: '#3e3e3e', fontWeight: 400}}>
                  {params.row.coordinates.coordinates[0]}, {params.row.coordinates.coordinates[1]}
                </Typography>
              }
            </Card>
          </Box>
        </Box>
      ),
    },
    {
      field: 'service',
      headerName: 'Service Detail',
      headerAlign: 'center',
      flex: 2,
      sortable: false,
      // valueGetter: (params) => {
      //   // Join all subcategory titles into a single searchable string
      //   const categoryTitle = params.row.ServiceCategoryRels[0]?.ServiceCategory?.parentCategory.title;
      //   const subCategoryTitle = params.row.ServiceCategoryRels[0]?.ServiceCategory?.title;
      //   return categoryTitle ? `${subCategoryTitle} (${categoryTitle})` : subCategoryTitle;
      // },
      renderCell: (params) => (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
          <Typography variant='body2' sx={{ fontWeight: 600, fontSize: '0.7rem' }}>{params.row.serviceTitle}</Typography>
          <Typography variant='caption' sx={{ fontWeight: 400, fontSize: '0.5rem' }}>{`( ${params.row.masterSTtitle} )`} </Typography>
        </Box>
      ),
    },
    {
      field: 'category',
      headerName: 'Category Detail',
      headerAlign: 'center',
      flex: 2,
      sortable: false,
      // valueGetter: (params) => {
      //   // Join all subcategory titles into a single searchable string
      //   const categoryTitle = params.row.ServiceCategoryRels[0]?.ServiceCategory?.parentCategory.title;
      //   const subCategoryTitle = params.row.ServiceCategoryRels[0]?.ServiceCategory?.title;
      //   return categoryTitle ? `${subCategoryTitle} (${categoryTitle})` : subCategoryTitle;
      // },
      renderCell: (params) => (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
          <Typography variant='body2' sx={{ fontWeight: 600, fontSize: '0.7rem' }}>{params.row.subCatTitle}</Typography>
          <Typography variant='caption' sx={{ fontWeight: 400, fontSize: '0.5rem' }}>{`( ${params.row.catTitle} )`}</Typography>
        </Box>
      ),
    },
    {
      field: 'brand',
      headerName: 'Brand',
      headerAlign: 'center',
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
          <Typography variant='body2' sx={{ fontWeight: 600, fontSize: '0.7rem',color:'#1976d2' }}>{params.row.brandTitle}</Typography>
          {/* <Typography variant='caption' sx={{ fontWeight: 400, fontSize: '0.5rem' }}>{`( ${params.row.catTitle} )`}</Typography> */}
        </Box>
      ),
    },
    {
      field: 'other',
      headerName: 'Other Detail',
      headerAlign: 'center',
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        <Box sx={{ width: '100%', m: 'auto' }}>
          <Box sx={{display:'flex'}}>
            <Typography sx={{fontWeight:500,fontSize:'.65rem',flex:1}}>Price</Typography>
            <Typography sx={{fontWeight:500,fontSize:'.65rem',flex:0.25}}>:</Typography>
            <Typography sx={{ fontSize: '0.65rem', color: '#3e3e3e', fontWeight: 400,flex:2 }}>     
              ₹ {params.row.price}
            </Typography>
          </Box>
          <Box sx={{display:'flex'}}>
            <Typography sx={{fontWeight:500,fontSize:'.65rem',flex:1}}> Time</Typography>
            <Typography sx={{fontWeight:500,fontSize:'.65rem',flex:0.25}}>:</Typography>
            <Typography sx={{ fontSize: '0.65rem', color: '#3e3e3e', fontWeight: 400,flex:2 }}>     
              {params.row.serviceTime} mins.
            </Typography>
          </Box>
        </Box>
      ),
    }
    
  ];

  // Initialize paginationModel state with potential localStorage backup
  const [paginationModel, setPaginationModel] = useState(
    {
      page: 0,
      pageSize: 20,
      filters: {
        searchKey: "",
        sortBy: 'id',
        sortType: 'desc',
        filterOptions: [],
      }
    });

  // State management
  const [allRowCount, setAllRowCount] = useState(0);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [isInitialLoad, setIsInitialLoad] = useState(true);

  const fetchList = async ()=>{
    try {
      setLoading(true);
      const listResponse = await materializeViewServices.materializedViewList({
        page: paginationModel.page,
        limit: paginationModel.pageSize,
        filters: {
          searchKey: paginationModel.filters.searchKey,
          sortBy: paginationModel.filters.sortBy,
          sortType: paginationModel.filters.sortType,
          filterOptions: paginationModel.filters.filterOptions || []
        }
      });

      if (listResponse.success == '1') {
        console.log("no. of items:", listResponse.data.list?.length);
        setList(listResponse.data.list);
        setAllRowCount(listResponse.data.totalItems);
      } else {
        setList([]);
        setAllRowCount(0);
      }
    } catch (error) {
      Swal.fire(error.message, '', 'error');
    }
    setLoading(false);
  }

  // Data fetching effect
  useEffect(() => {
    const getData = async () => {
      // Skip initial unnecessary fetch
      if (isInitialLoad) {
        setIsInitialLoad(false);
        return;
      }

      fetchList();
    };
    getData();
  }, [paginationModel, isInitialLoad]);

  // Pagination change handler
  const handlePaginationChange = (newPagination) => {
    setPaginationModel(prev => ({
      ...prev,
      page: newPagination.page,
      pageSize: newPagination.pageSize
    }));
  };


  // Form handling for filters
  const filterFormMethod = useForm();
  const { control, handleSubmit, reset, setValue, getValues, formState: { errors }, watch } = filterFormMethod;

  // Filter submission handler
  function onSubmit(data) {
    const filtersData = getValues();
    setPaginationModel(prev => ({
      ...prev,
      filters: {
        ...prev.filters,
        searchKey: filtersData.searchKey,
      }
    }));
  }

  // Clear filters handler
  const clearFilters = () => {
    reset();
    setPaginationModel(prev => ({
      ...prev,
      filters: {
        searchKey: "",
        // status: 1,
        sortBy: 'createdAt',
        sortType: 'desc',
        filterOptions: []
      }
    }));

    // Trigger clear for MultiColumnFilter
    setClearMultiFilter(true);

    // Reset the clear trigger after a short delay
    setTimeout(() => setClearMultiFilter(false), 100);
  };

  /************************  Table Column Manage **************************** */

  // State to track expanded rows
  const [expandedRowIds, setExpandedRowIds] = useState({});

  // Toggle expansion for expert categories of a specific row
  const toggleRowExpansion = (rowId) => {
    setExpandedRowIds(prev => ({
      ...prev,
      [rowId]: !prev[rowId]
    }));
  };

  /************************  Advance Filter **************************** */


  const [clearMultiFilter, setClearMultiFilter] = useState(false);

  const filterableColumns = [
    // {
    //   key: 'profile',
    //   label: 'Profile',
    //   type: 'select',
    //   options: [
    //     { value: 'complete', label: 'complete' },
    //     { value: 'incomplete', label: 'in-complete' }
    //   ]
    // },
    {
      key: 'name',
      label: 'Name',
      type: 'text'
    },
    {
      key: 'mobileNumber',
      label: 'Mobile',
      type: 'number'
    },
  ];

  const handleApplyFilter = (filterData) => {
    // Process filter data
    console.log(filterData);
    setPaginationModel({
      ...paginationModel,
      page: 0, // Reset to first page when applying new filters
      filters: {
        ...paginationModel.filters,
        // Convert MultiColumnFilter options to a format your backend can understand
        filterOptions: filterData.filterOption.filter(filter => filter.fieldName && filter.value) // Remove empty filters
      }
    });
  }

  /************* quick search related **************/
  const [quickFilterText, setQuickFilterText] = useState('');
  // Properly structured filter model
  const [filterModel, setFilterModel] = useState({
    items: [],
    quickFilterValues: []
  });

  // Update filter model when quick filter text changes
  useEffect(() => {
    setFilterModel(prevModel => ({
      ...prevModel,
      quickFilterValues: quickFilterText ? [quickFilterText] : []
    }));
  }, [quickFilterText]);

  /******************* Sorting model  ******************************/
  const [sortModel, setSortModel] = useState([
    {
      field: paginationModel.filters.sortBy,
      sort: paginationModel.filters.sortType,
    },
  ]);

  const handleSortingChange = (newSortModel) => {
    console.log("new sort model", newSortModel);
    if (newSortModel && newSortModel.length > 0) {
      setSortModel(newSortModel);
      setPaginationModel(prev => ({
        ...prev,
        filters: {
          ...prev.filters,
          sortBy: newSortModel[0].field,
          sortType: newSortModel[0].sort
        }
      }));
    }
    // else{
    //   setSortModel([{
    //     field: 'createdAt',
    //     sort: 'asc',
    //   }]);
    //   setPaginationModel(prev => ({
    //     ...prev,
    //     filters: {
    //       ...prev.filters,
    //       sortBy: 'createdAt',
    //       sortType: 'asc'
    //     }
    //   }));
    // }
  }
  return (
    <>
        <PageHeaderLayout headerTitle={'Materialize Data'}>
            <Button variant='contained' onClick={() => handleRefreshList()} sx={{ height: "30px", marginTop: "10px" }} startIcon={<Refresh />}>
                Refresh List
            </Button>
        </PageHeaderLayout>
      {loading && <Loading />}
      
      {/*  */}

      <Card sx={{ overflow: "auto" }}>
        <Box sx={{ width: "100%", display: "table", tableLayout: "fixed", backgroundColor: "#fff" }}>
          <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center', px: '1%' }}>
            
            {/* <QuickSearchTool filterModel={filterModel} setFilterModel={setFilterModel} />             */}
            <Box sx={{width:{xs:'75%',sm:'40%'}}}>
              {/* <QuickSearchTool filterModel={filterModel} setFilterModel={setFilterModel} /> */}
              <FormProvider {...filterFormMethod}>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <Grid container spacing={1} sx={{ p: '.5%' }}>
                    <Grid item xs={9} lg={8}>
                      <Controller
                        name="searchKey"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <TextField
                            {...field}
                            placeholder="Search by name,mobile,service,category "
                            // label="Search"
                            size="small"
                            fullWidth
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                paddingLeft: '0px',
                              }
                            }}
                            InputProps={{  // Changed from slotProps to InputProps
                              inputProps: {
                                style: {
                                  height: '0.6rem',
                                  // textTransform: 'uppercase',
                                  fontSize: 'x-small'
                                },
                              },
                            }}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={3} lg={4}>
                      <Tooltip title="Search" sx={{ ml: 1, p: 0 }}>
                        <IconButton
                          size='small'
                          color="primary"
                          type="submit"
                          sx={{ border: "1px solid", borderRadius: "7px", padding: "1%", ml: 1 }}
                        >
                          <SearchIcon sx={{ fontSize: '.85rem' }} />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Clear All Filters">
                        <IconButton
                          size='small'
                          color="primary"
                          sx={{ marginLeft: "10px", border: "1px solid", color: "#f00", borderRadius: "7px", padding: "1%" }}
                          onClick={clearFilters}
                        >
                          <RestartAltIcon sx={{ fontSize: '.85rem' }} />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </form>
              </FormProvider>
            </Box>
            
          </Box>
          <DataGrid
            rows={list}
            columns={columns.map((col) => ({
              ...col,
              // flex: isSmallScreen && (col.flex || 1), // Ensure columns resize dynamically
              minWidth: isSmallScreen && (col.minWidth || 180), // Set a minimum width to avoid overlap
            }))}
            rowCount={allRowCount}
            pageSizeOptions={[5, 10, 20, 50, 100]}
            paginationModel={paginationModel}
            paginationMode="server"
            onPaginationModelChange={handlePaginationChange}
            filterModel={filterModel}


            sortingMode="server"
            sortModel={sortModel}
            onSortModelChange={handleSortingChange}
            disableMultiSort={true}

            loading={loading}
            disableColumnMenu
            disableRowSelectionOnClick
            slots={{
              // toolbar: GridToolbar,   
              loadingOverlay: Loading,
              noRowsOverlay: NoRowsLayout,
            }}
            autoHeight
            getRowHeight={() => 'auto'}
            sx={{
              lineHeight: 1,
              borderTopLeftRadius:0,
              borderLeft:0,
              '& .MuiDataGrid-cell': {
                // first cell borderLeft:0
                
                border: 1,
                borderRight: 0,
                borderTop: 0,
                borderColor: 'lightgrey',
                display: 'flex',
                alignItems: 'center',
                // justifyContent: 'center',
              },
              '& .MuiDataGrid-columnHeaders': {
                borderBottom: '2px solid rgba(224, 224, 224, 1)',
                // borderTop: '2px solid rgba(224, 224, 224, 1)',
                fontWeight: 600,
                fontSize: '0.75rem',
                p: 0,
                // height: 'fit-content',
                minHeight: '0 !important',
                height: '2rem'
              },
              '& .MuiDataGrid-columnHeader': {
                borderLeft: '1px solid rgba(224, 224, 224, 1)',
                '&:last-child': {
                  borderRight: 'none',
                },
              },
              '& .MuiDataGrid-columnHeaderTitle': {
                fontWeight: 600,
                color: '#3e3e3e'
              },
              '& .MuiDataGrid-row': {
                '&:last-child .MuiDataGrid-cell': {
                  borderBottom: '1px solid rgba(224, 224, 224, 1)',
                },
                '& .MuiDataGrid-cell:last-child': {
                  borderRight: 'none',
                },
              },
              '& .MuiDataGrid-columnSeparator': {
                display: 'none',
              },
            }}
          />
        </Box>
      </Card>
    </>
  )
}
